let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eVmUe")).then(() => parcelRequire('81ffx'));